import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KYMW5500Component } from './kymw5500.component';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { GetImageFileListService } from './api-services/get-image-file-list.service';
import { UpdateImageFileListService } from './api-services/update-image-file-list.service';
import { KYMW0D00Module } from '../../../commons/kymw0d/kymw0d00/kymw0d00.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
/**
 * EC画像メンテ画面 モジュール設定クラス
 *
 * @export KYMW5500Module
 * @class KYMW5500Module
 */
@NgModule({
  imports: [
    CommonModule,
    PlessSharedModule,
    WjNavModule,
    WjGridModule,
    KYMW0D00Module,
    AppCommonsModule,
  ],
  declarations: [
    KYMW5500Component,
  ],
  providers: [
    GetImageFileListService,
    UpdateImageFileListService,
  ],
})

export class KYMW5500Module { }
